import { mutation, query, simpleMutation } from "@/api"
import { sortByReverse } from "@/helpers/node_gm_common"
import { ICategory } from "@/types"
import { Commit, Dispatch, ActionTree } from "vuex"
import { addVuexEntity, addVuexEntityCRUD } from ".."
import { isRu } from "@/helpers"

export interface CategoriesState {
    categories: ICategory[]
}
const module = {
    state() {
        const state = {

        } as CategoriesState
        return state
    },
    mutations: {

    },
    actions: {

    }
}


const apiCall = async () => {
    const res = await query("categoriesAll", ["id", "name", "content", "count"], {language: isRu() ? "ru" : undefined})
    return sortByReverse(res, el => el.count)
}

const apiCalls = {
    get: apiCall,
    async add(value: ICategory) {
        const res = await mutation("createCategory", {name: value.name}, ["id", "name", "content"])
        return res
    },
    async edit(value: Partial<ICategory>) {
        const res = await mutation("updateCategory", {_id: value.id, ...value }, ["id", "name"]);
        return res
    },
    async del(id: string) {
        const res = await simpleMutation("deleteCategory", "_id", id);
        return res
    },
}

addVuexEntityCRUD(module, "categories", {} as any, apiCalls)

export default module
